import Vue from 'vue'
import Router from 'vue-router'
import PopBox from '@/components/PopBox.vue'
import PopCate from '@/components/PopCate.vue'

Vue.use(Router)

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/booth/:boothId',
            name: 'PopBox',
            component: PopBox
        },
        {
            path: '/schedule/:scheduleId',
            name: 'PopBox',
            component: PopBox
        },
        {
            path: '/product/:productCate',
            name: 'PopCate',
            component: PopCate
        },
        {
            path: '/product/:productCate/:productId',
            name: 'PopBox',
            component: PopBox
        },
        {
            path: '/about',
            name: 'about',
            component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
        }
    ]
})
